// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3A7aW","footer":"ModalCreateQualiphyProcedure_footer__1zcS-","additionData":"ModalCreateQualiphyProcedure_additionData__3aExw"};